/**
 * OrderButton Component
 */

import { linkWithCurrentQueryString } from '../../../../utils/router';
import './order-button.scss';

import { Link } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import { IconTermsLarge, IconWarningLarge } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import { OrderPagePath } from './';

interface IOwnProps {
  id: string;
  isPastDue?: boolean;
  title: string;
  subtitle: string;
  onSelect(): void;
}

type OrderButtonProps = IOwnProps & IDispatchProps;

const classes = new BEM({ name: 'order-button', outputIsString: true });

function OrderButton(props: OrderButtonProps) {
  return (
    <Link
      to={linkWithCurrentQueryString(OrderPagePath(props.id))}
      activeClassName={classes('', 'active')}
      className={classes()}
      onClick={props.onSelect}
    >
      {props.isPastDue ?
        <IconWarningLarge className={classes('icon', 'warning')} />
        : <IconTermsLarge className={classes('icon')} />}
      <div className={classes('info')}>
        <Heading
          is="h5"
          text={props.title}
          maxTextLength={25}
          noMargin
          className={classes('title')}
        />
        <Span variant="note" size="medium" className={classes('subtitle')}>{props.subtitle}</Span>
      </div>
    </Link>
  );
}

const OrderedProjectButton = connect()(OrderButton);

export default OrderedProjectButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Orders/OrderButton.tsx